import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-722c0bfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative w-full" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]

import { onUpdated, ref, computed, onMounted, onUnmounted } from 'vue'
import type { Ref } from 'vue'
import { gsap } from 'gsap'
import { ScrollToPlugin } from '@/assets/js/ScrollToPlugin.min.js'
import { useEventBus } from '@vueuse/core'
import { MJPSection } from '../magicjohnsonpark/types'

interface Props {
  currentSection: string
  currentPage: number
  thisSection: string
  currentSectionHasLoaded: boolean
  activeHotspotId?: string
  forward: boolean
  screenHeights: number
  pageMap: Array<number>
  disableScrollSnap?: boolean
  disableKeyNavigation?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollEngine',
  props: {
    currentSection: null,
    currentPage: null,
    thisSection: null,
    currentSectionHasLoaded: { type: Boolean },
    activeHotspotId: null,
    forward: { type: Boolean },
    screenHeights: null,
    pageMap: null,
    disableScrollSnap: { type: Boolean },
    disableKeyNavigation: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  currentSection: string
  currentPage: number
  thisSection: string
  currentSectionHasLoaded: boolean
  activeHotspotId?: string
  forward: boolean
  screenHeights: number
  pageMap: Array<number>
  disableScrollSnap?: boolean
  disableKeyNavigation?: boolean
}

gsap.registerPlugin(ScrollToPlugin)

// creates empty divs equal to the height of the
// number of "pages" we will be scrolling through;
// used to track scroll progress


const element: Ref<HTMLElement | null> = ref(null)
let lastLoaded = 'none'
const hotspotClickedBus = useEventBus('hotspot-clicked')
const sectionPageBus = useEventBus('section-page-bus')
const windowSize = {
  x: window.innerWidth,
  y: window.innerHeight,
}
const keyCodes = {
  ESC: 27,
  UpArrow: 38,
  DownArrow: 40,
}

const handleResize = () => {
  updateWindowSize()
}

const updateWindowSize = () => {
  windowSize.x = window.innerWidth
  windowSize.y = window.innerHeight
}

const classes = computed(() => {
  if (
    !props.disableScrollSnap &&
    props.currentSection == props.thisSection &&
    props.currentSectionHasLoaded
  ) {
    return 'snap-mandatory snap-y'
  } else {
    return ''
  }
})

const snapClasses = computed(() => {
  if (
    !props.disableScrollSnap &&
    props.currentSection == props.thisSection &&
    props.currentSectionHasLoaded
  ) {
    return 'snap-center snap-always'
  } else {
    return ''
  }
})

const handleKeyDown = (e) => {
  var keyCode = e.keyCode || e.which

  switch (keyCode) {
    case keyCodes.ESC:
      e.preventDefault()
      hotspotClickedBus.emit(-1)
      break

    case keyCodes.UpArrow:
      if (!props.disableKeyNavigation) previousScreenPage()
      break

    case keyCodes.DownArrow:
      if (!props.disableKeyNavigation) nextScreenPage()
      break

    default:
      break
  }
}

const previousScreenPage = () => {
  if (element.value) {
    const screenPage = Math.ceil(element.value.scrollTop / windowSize.y)
    gsap.to(element.value, {
      scrollTo: `#${props.currentSection}-page-${screenPage - 1}`,
      duration: 1,
    })
  }
}

const nextScreenPage = () => {
  if (element.value) {
    const screenPage = Math.ceil(element.value.scrollTop / windowSize.y)
    gsap.to(element.value, {
      scrollTo: `#${props.currentSection}-page-${screenPage + 1}`,
      duration: 1,
    })
  }
}

const handleBackgroundClick = (evt) => {
  if (props.activeHotspotId != '') {
    hotspotClickedBus.emit(-1)
  }
}

sectionPageBus.on((direction) => {
  console.log('nav section ' + direction)
  if (direction === 1) nextScreenPage()
  else if (direction === -1) previousScreenPage()
})

onUpdated(() => {
  if (element.value) {
    let el: HTMLElement = element.value
    if (
      props.currentSection == props.thisSection &&
      props.currentSectionHasLoaded &&
      props.currentSection != lastLoaded
    ) {
      if (props.forward) {
        gsap.fromTo(
          element.value,
          { scrollTo: 0 },
          {
            scrollTo: windowSize.y * 0.5,
            duration: 1,
            delay: 1,
          }
        )
      } else {
        gsap.fromTo(
          element.value,
          { scrollTo: el.scrollHeight - windowSize.y * 1.5 },
          {
            scrollTo: el.scrollHeight - windowSize.y * 1.5,
            duration: 1,
            delay: 0,
          }
        )
      }
    }
    lastLoaded = props.currentSection
  }
})

onMounted(() => {
  document.addEventListener('keydown', handleKeyDown, false)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyDown)
})

return (_ctx: any,_cache: any) => {
  const _directive_resize = _resolveDirective("resize")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref_key: "element",
    ref: element,
    class: _normalizeClass(["scroll-engine border-2 border-transparent absolute top-0 left-0 w-full h-full overflow-y-scroll", _unref(classes)]),
    onClick: handleBackgroundClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        id: `${props.currentSection}-page-0`,
        class: _normalizeClass(["w-full h-[50vh] text-xl flex items-center justify-center", _unref(snapClasses)])
      }, null, 10, _hoisted_2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.screenHeights - 1, (i) => {
        return (_openBlock(), _createElementBlock("div", {
          id: `${props.currentSection}-page-${i}`,
          key: i,
          class: _normalizeClass(["w-full h-[100vh] text-xl flex items-center justify-center", _unref(snapClasses)])
        }, null, 10, _hoisted_3))
      }), 128)),
      _createElementVNode("div", {
        id: `${props.currentSection}-page-${props.screenHeights}`,
        class: _normalizeClass(["w-full h-[50vh] text-xl flex items-center justify-center", _unref(snapClasses)])
      }, null, 10, _hoisted_4),
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2)), [
    [_directive_resize, handleResize]
  ])
}
}

})